module.exports = __webpack_public_path__ + "img/half-profile-report.594c0c23.svg";